// [WPLITE-PASSKEY] Lógica de decisão do fluxo de conexão por passkey (Meta Shortcake).
// Pura e sem Vue de propósito → testável isolada e reusável entre o dashboard e a página
// de conexão remota. O backend surfa o bloco `passkey` no status só com WPLITE_PASSKEY_ENABLED;
// quando ausente, `resolvePasskeyView` devolve { kind: 'none' } e nenhuma UI de passkey aparece.

// Extensão publicada na Chrome Web Store (ID estável de produção).
export const EXTENSION_ID = 'agpkobiikioenfcidchclgbiglabclpk';
export const EXTENSION_INSTALL_URL = `https://chromewebstore.google.com/detail/${EXTENSION_ID}`;

// Detecção POR NAVEGADOR/PERFIL, em runtime. NUNCA persistir "instalou=true" na conta —
// a mesma pessoa cai no gate de outro navegador/perfil/máquina. O marcador é posto pelo
// content-script da extensão (bridge.js) no MAIN world de crm.starcontent.com.br.
export function isExtensionInstalled(
  win = typeof window !== 'undefined' ? window : undefined
) {
  // eslint-disable-next-line no-underscore-dangle
  return Boolean(win && win.__starcontent_ext === true);
}

// Decide o que o painel de passkey deve mostrar.
// @param passkey  bloco do status: { method, state, import_url } | null | undefined
// @param extensionInstalled  resultado de isExtensionInstalled()
// Retorna um dos kinds:
//   'none'          → sem passkey (flag off ou bloco ausente) → não renderiza nada
//   'idle'          → provider suporta passkey mas a conta não está no fluxo agora
//   'migrate'       → provider sem saída nativa (evolution clássico) → aviso de migração
//   'install_gate'  → fluxo ativo mas a extensão não está neste navegador
//   'connect'       → pronto pra abrir o WhatsApp Web (openUrl + code opcional)
// Há fluxo de passkey a mostrar pra este bloco? Depende só de method/state/import_url
// (NÃO da extensão — ela só muda QUAL sub-view aparece, não SE aparece). Fonte única do
// gate de render: reusado pelo showPasskeyPanel do Settings.vue e por resolvePasskeyView.
export function hasPasskeyFlow(passkey) {
  if (!passkey || !passkey.method) return false;
  if (passkey.method === 'none') return true; // aviso de migração
  if (passkey.method === 'ceremony') return Boolean(passkey.state);
  return Boolean(passkey.import_url); // session_transfer
}

export function resolvePasskeyView({ passkey, extensionInstalled } = {}) {
  if (!passkey || !passkey.method) return { kind: 'none' };

  const { method, state, import_url: importUrl } = passkey;

  // evolution clássico: sem cerimônia nem import → só resta migrar.
  if (method === 'none') return { kind: 'migrate' };

  // Fluxo ativo? (cerimônia depende do state efêmero; import, do link).
  if (!hasPasskeyFlow(passkey)) return { kind: 'idle' };

  // uazapi (session_transfer): o link /import/ do uazapi resolve instalação-OU-migração
  // sozinho → NÃO gateamos pela NOSSA extensão (nosso marcador nem detecta a extensão deles).
  if (method === 'session_transfer') {
    return { kind: 'connect', method, openUrl: importUrl, code: null };
  }

  // evogo (cerimônia): precisa da NOSSA extensão neste navegador.
  if (!extensionInstalled) return { kind: 'install_gate', method };

  const openUrl = state?.open_url;
  if (!openUrl) return { kind: 'idle' };

  return { kind: 'connect', method, openUrl, code: state?.code || null };
}
